// react
import { Suspense } from 'react';

// tanstack
import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

// shared components
import { ServiceGuard } from '@/components/access-control/ServiceGuard';

export const Route = createFileRoute('/$accountId/_user/datahub-integration')({
  component: () => (
    <ServiceGuard
      serviceNames={['DatahubIntegration']}
      fallback={<Navigate to="/$accountId" />}
    >
      <Suspense>
        <Outlet />
      </Suspense>
    </ServiceGuard>
  ),
  staticData: { crumb: 'datahub-integration:title' },
});
